import Vue from "vue";
import LoginModal from "./LoginModal.vue";
const modal = Vue.extend(LoginModal);
LoginModal.login = function (option) {
  let instance = new modal().$mount();
  document.body.appendChild(instance.$el);
  Object.assign(instance, option);
  instance.dialogVisible = true;
};
export default LoginModal;
